import { useState } from 'react';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import Toggle from 'components/Toggle';
import CreateBatteryForm from 'components/forms/CreateBatteryForm';
import CreateDroneForm from 'components/forms/CreateDroneForm';

import useTranslation from './hooks/useTranslation';

import { ASSET_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CreateAssetForm: FunctionComponent<Props> = ({
    onCancelClose,
    onClose,
    requestingClose,
    testId = TEST_ID
}) => {
    const { BATTERY_BUTTON_TEXT, DRONE_BUTTON_TEXT } = useTranslation();
    const [selectedAssetType, setSelectedAssetType] = useState<ASSET_TYPE | null>(
        ASSET_TYPE.BATTERY
    );

    const toggleOptions = [
        {
            label: DRONE_BUTTON_TEXT,
            value: ASSET_TYPE.DRONE
        },
        {
            label: BATTERY_BUTTON_TEXT,
            value: ASSET_TYPE.BATTERY
        }
    ];

    const handleToggleClick = (option: string) => {
        setSelectedAssetType(option as ASSET_TYPE);
    };

    return (
        <VerticalContainer className={styles.createAssetForm} testId={testId}>
            <Toggle
                activeIndex={selectedAssetType === ASSET_TYPE.DRONE ? 0 : 1}
                onClick={handleToggleClick}
                options={toggleOptions}
            />

            {selectedAssetType === ASSET_TYPE.DRONE ? (
                <CreateDroneForm
                    onCancelClose={onCancelClose}
                    onClose={onClose}
                    requestingClose={requestingClose}
                />
            ) : (
                <CreateBatteryForm
                    onCancelClose={onCancelClose}
                    onClose={onClose}
                    requestingClose={requestingClose}
                />
            )}
        </VerticalContainer>
    );
};

export default CreateAssetForm;
